module.exports = __webpack_public_path__ + "img/alfamart-light.9e33e6ef.png";